import { Backdrop, Box, IconButton, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FEEDBACK_FORM_DISPLAY_DELAY, FEEDBACK_FORM_SRC } from "../../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { logFeedBackTime, showFeedbackSurvey } from "../../../store/actions";

export default function FeedbackForm({ customWaitTime = 0 }) {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const user = useSelector(({ Auth }) => Auth.user);
    const refrenceId = useSelector(({ transfer }) => transfer.lastRefId);
    const showFeedbackForm = useSelector(({ Auth }) => Auth.feedbackSurveyState);
    const logOpenTime = () => {
        dispatch(logFeedBackTime(false))
    }
    const handleOpen = () => {

        const _customWaitTime = parseFloat(customWaitTime);
        const _waitTime = _customWaitTime > 0 ? _customWaitTime : FEEDBACK_FORM_DISPLAY_DELAY;
        if (!showFeedbackForm) {
            return;
        }
        setTimeout(() => {
            setOpen(true)
            logOpenTime()
        }, (_waitTime * 1000))
    };
    const handleClose = () => setOpen(false);

    const handleSuccess = () => {
        handleOpen();
    }
    useEffect(() => {
        dispatch(showFeedbackSurvey(handleSuccess));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const parseFormSrc = () => {
        return FEEDBACK_FORM_SRC.replace('%email%', user?.email).replace('%referenceId%', refrenceId)
    }
    return (
        <Box>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
            >

                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '75vw',
                    maxWidth: '400px',
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: '20px'
                }}
                >
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="tracker"
                        aria-describedby="close_feedback"
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: '20px'
                        }}
                    >
                        <CloseIcon htmlColor="#03284b" aria-label="tracker"
                            aria-describedby="close_feedback" />
                    </IconButton>
                    <iframe src={parseFormSrc()} className="feedback-form" title="Feedback Form">Loading…</iframe>
                </Box>
            </Modal>
        </Box >
    );
}; 